export default __webpack_public_path__ + "static/media/fpb50030.19bcffa6.png";